import { Badge, Card, Container, Divider, Grid, Group, Stack, Text, Title } from '@mantine/core';
import { IconShieldLock } from '@tabler/icons-react';
import dayjs from 'dayjs';
import { useAuthStore } from '../../auth/auth-store';
import { ChangePasswordForm } from '../../auth/ChangePasswordForm';
import { MfaPanel } from './MfaPanel';

export function ProfilePage() {
  const user = useAuthStore((s) => s.user);
  if (!user) return null;

  return (
    <Container size="md">
      <Stack gap="lg">
        <Stack gap={4}>
          <Title order={2}>Profile</Title>
          <Text c="dimmed" size="sm">
            View your account and change your password.
          </Text>
        </Stack>

        <Card withBorder padding="lg" radius="md">
          <Grid>
            <InfoCell label="Username" value={user.username} />
            <InfoCell label="Email" value={user.email} />
            <InfoCell label="System role" value={user.system_role} />
            <Grid.Col span={{ base: 12, sm: 6 }}>
              <Text size="xs" c="dimmed" fw={500} tt="uppercase">
                Status
              </Text>
              <Group gap="xs" mt={4}>
                <Badge color={user.is_active ? 'pine' : 'gray'} variant="light">
                  {user.is_active ? 'active' : 'inactive'}
                </Badge>
                {user.email_verified && (
                  <Badge color="blue" variant="light">
                    email verified
                  </Badge>
                )}
                {user.mfa_enabled && (
                  <Badge color="teal" variant="light">
                    MFA
                  </Badge>
                )}
              </Group>
            </Grid.Col>
            <InfoCell
              label="Last sign-in"
              value={
                user.last_login_at ? dayjs(user.last_login_at).format('YYYY-MM-DD HH:mm') : '—'
              }
            />
          </Grid>
        </Card>

        <Divider />

        <Card withBorder padding="lg" radius="md">
          <Group gap="sm" mb="md">
            <IconShieldLock size={20} />
            <Title order={4}>Change password</Title>
          </Group>
          <ChangePasswordForm />
        </Card>

        <MfaPanel />
      </Stack>
    </Container>
  );
}

function InfoCell({ label, value }: { label: string; value: string }) {
  return (
    <Grid.Col span={{ base: 12, sm: 6 }}>
      <Text size="xs" c="dimmed" fw={500} tt="uppercase">
        {label}
      </Text>
      <Text>{value}</Text>
    </Grid.Col>
  );
}
